import SetupProfileSetup from 'src/components/sommlike/sommelier-setup';

const SommelierSetup = () => {
  return <SetupProfileSetup />;
};

export default SommelierSetup;
